import { name, version } from '../package.json';
import { positions } from '@mds/utils-js';

export default {
    autoPosition: {
        type: Boolean,
        default: false,
        docs: {
            validation: '—',
            description:
                'If `true`, tooltip will be positioned based on available window space defaulting to top-center. Can be overridden by position prop.',
        },
    },
    fixed: {
        type: Boolean,
        default: false,
        docs: {
            validation: '—',
            description:
                'When a tooltip is triggered from an element or container set to `position: fixed;`, this prop must be set `true` to ensure proper positioning.',
        },
    },
    dismissIconAriaLabel: {
        type: String,
        default: 'Dismiss',
        docs: {
            validation: '—',
            description: 'Sets the `aria-label` attribute on the icon-only dismiss button.',
        },
    },
    position: {
        type: String,
        default: null,
        validator: value => positions.indexOf(value) > -1,
        docs: {
            validation:
                'One of `top-center`, `top-right`, `top-left`, `bottom-center`, `bottom-right`, `bottom-left`, `right-center`, `right-bottom`, `left-center`, `left-top`, `left-bottom`.',
            description: 'Sets the position of the tooltip relative to its triggering element.',
        },
    },

    size: {
        type: String,
        default: 'medium',
        validator: value => ['small', 'medium', 'large'].indexOf(value) > -1,
        docs: {
            validation: 'One of: `small`, `medium`, `large`.',
            description: 'Sets the size of the tooltip.',
        },
    },
    triggeredBy: {
        type: String,
        docs: {
            validation: '**Required**',
            description: 'The `id` of the element that triggers the tooltip',
        },
    },
    text: {
        type: String,
        docs: {
            validation: '**Required**',
            description: 'The text that appears in the tooltip. Can also be passed via the [default slot](#slots).',
        },
    },
    variation: {
        type: String,
        default: 'default',
        validator: value => ['default', 'error', 'prompt'].indexOf(value) > -1,
        docs: {
            validation: 'One of: `default`, `error`, `prompt`.',
            description: 'Sets the tooltip variation.',
        },
    },
    visible: {
        type: Boolean,
        default: false,
        docs: {
            validation: '—',
            description: 'Sets the visibility of the tooltip.',
            support: ['v-model'],
        },
    },
    version: {
        type: String,
        default: `${name}-${version}`,
        docs: {
            validation: 'Read-only',
            description:
                'Set automatically by package version, do not manually adjust this prop. Used to add a data attribute providing the component version to the component markup rendered in the DOM.',
        },
    },
};
